export const DEFAULT_TIMEZONE = 'America/Los_Angeles'



// WEBPACK FOOTER //
// ./src/constants.js